// extracted by mini-css-extract-plugin
module.exports = {"clickableTag":"styles_clickableTag__2yNGReW0iz0_F0mQx_vgZz"};